<template>
  <div class="test-details-container">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <b-button size="sm" variant="outline-secondary" @click="$emit('close')">
        Retour à la liste des tests
      </b-button>
    </div>

    <b-tabs pills card vertical>
      <TestInfo :test="test" @scores-changed="onScoresChanged" @saved="onChildSaved" />
      <TestItems :test="test" />
      <TestGroups :test="test" />

      <TestReportPdf :test="test" />

      <b-tab title="Items intermédiaires">
        <CertificatCommentsNormatif :testId="test._id || test.id" />
      </b-tab>
<b-tab title="Combinaisons">
  <TestCombinaisons :testId="test._id || test.id" />
</b-tab>

      <b-tab title="Énergies">
        <PdfParametersNeuroscience :testId="test._id || test.id" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TestInfo from './TestInfo.vue';
import TestItems from './TestItems.vue';
import TestGroups from './TestGroups.vue';
import TestReportPdf from './TestReportPdf.vue';
import CertificatCommentsNormatif from './CertificatCommentsNormatif.vue';
import PdfParametersNeuroscience from '../NeuroscienceEvaluation/PdfParametersNeuroscience.vue';
import TestCombinaisons from './TestCombinaisons.vue';

export default {
  name: "TestDetails",
  props: { test: { type: Object, required: true } },
  components: {
    TestInfo,
    TestItems,
    TestGroups,
    TestReportPdf,
    CertificatCommentsNormatif,
    PdfParametersNeuroscience,
    TestCombinaisons
  },
  methods: {
    onScoresChanged(newScores) {},
    onChildSaved() {}
  }
};
</script>
